import { render, staticRenderFns } from "./ReviewCustomerExamComponent.vue?vue&type=template&id=d476282a&scoped=true&"
import script from "./ReviewCustomerExamComponent.vue?vue&type=script&lang=js&"
export * from "./ReviewCustomerExamComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReviewCustomerExamComponent.vue?vue&type=style&index=0&id=d476282a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d476282a",
  null
  
)

export default component.exports